<template>
  <section id="listUsers">
    <!-- Add User -->
    <AddUser @added="refresh" />
    <!-- Table View -->
    <VueDatatable ref="myTable" :setupTable="setupTable">
      <template v-slot:thead>
        <tr>
          <th class="id-col" style="width: 59px">
            <span>ID</span>
          </th>
          <th style="width: 65px">Username</th>
          <th>E-mail</th>
          <th>Country</th>
          <th class="none">Provider</th>
          <th>Group</th>
          <th>Created</th>
          <th class="none">Credit</th>
          <th>Actions</th>
        </tr>
      </template>
    </VueDatatable>
    <!-- Edit User -->
    <EditUser @updated="refresh" />

    <!-- Notify User Modal -->
    <b-modal
      id="notify-user-modal"
      ref="notifyModal"
      centered
      no-close-on-backdrop
      @ok="sendNotify"
      @hidden="resetNotify"
    >
      <template #modal-title>
        Send to User
      </template>

      <template #modal-ok>
        <span v-if="!notify.sending">Send</span>
        <b-spinner v-else small />
      </template>

      <!-- User info -->
      <div class="d-flex align-items-center mb-1 p-75 rounded" style="background: rgba(115, 103, 240, 0.08); border: 1px solid rgba(115, 103, 240, 0.2);">
        <div>
          <strong>{{ notify.username }}</strong>
          <br />
          <small class="text-muted">{{ notify.email }}</small>
        </div>
      </div>

      <b-form-group label="Message" label-for="notify-message">
        <b-form-textarea
          id="notify-message"
          v-model="notify.message"
          rows="5"
          placeholder="Type your message here..."
        />
      </b-form-group>

      <div class="d-flex align-items-center mt-1">
        <span class="mr-1" :class="{ 'text-muted': notify.sendEmail }">Notification</span>
        <b-form-checkbox v-model="notify.sendEmail" switch />
        <span :class="{ 'text-muted': !notify.sendEmail }">Email</span>
      </div>
    </b-modal>
  </section>
</template>

<script>
import {
  BButton,
  BModal,
  BFormGroup,
  BFormTextarea,
  BFormCheckbox,
  BSpinner,
} from "bootstrap-vue";
import VueDatatable from "@/components/util/vue-datatable/Index.vue";
import { setupTable } from "@/datatable/users.datatable.js";
import EditUser from "./EditUser";
import AddUser from "./AddUser";
import api from "@axios";

export default {
  data: () => ({
    dataTable: null,
    setupTable,
    notify: {
      userId: null,
      username: "",
      email: "",
      message: "",
      sendEmail: false,
      sending: false,
    },
  }),
  async mounted() {
    this.dataTable = this.$refs.myTable;

    window.notifyUser = (id, username, email) => {
      this.notify.userId = id;
      this.notify.username = username;
      this.notify.email = email;
      this.$bvModal.show("notify-user-modal");
    };
  },
  beforeDestroy() {
    delete window.notifyUser;
  },
  methods: {
    refresh() {
      this.myTable.access().ajax.reload();
    },
    async sendNotify(bvModalEvt) {
      bvModalEvt.preventDefault();

      if (!this.notify.message.trim()) {
        this.$swal({
          icon: "warning",
          title: "Message is empty",
          text: "Please type a message before sending.",
          customClass: { confirmButton: "btn btn-primary" },
          buttonsStyling: false,
        });
        return;
      }

      this.notify.sending = true;
      try {
        await api.post("/new_notify_user", {
          user_id: this.notify.userId,
          message: this.notify.message,
          type: this.notify.sendEmail ? "email" : "notification",
        });

        this.$bvModal.hide("notify-user-modal");
        this.$swal({
          icon: "success",
          title: "Sent!",
          text: this.notify.sendEmail
            ? "Email sent successfully."
            : "Notification sent successfully.",
          customClass: { confirmButton: "btn btn-success" },
          buttonsStyling: false,
        });
      } catch (e) {
        const msg = e.response?.data?.message || "Something went wrong.";
        this.$swal({
          icon: "error",
          title: "Failed",
          text: msg,
          customClass: { confirmButton: "btn btn-primary" },
          buttonsStyling: false,
        });
      } finally {
        this.notify.sending = false;
      }
    },
    resetNotify() {
      this.notify.message = "";
      this.notify.sendEmail = false;
      this.notify.userId = null;
      this.notify.username = "";
      this.notify.email = "";
      this.notify.sending = false;
    },
  },
  computed: {
    myTable() {
      return this.dataTable || {};
    },
  },
  components: {
    BButton,
    BModal,
    BFormGroup,
    BFormTextarea,
    BFormCheckbox,
    BSpinner,
    VueDatatable,
    EditUser,
    AddUser,
  },
};
</script>

<style>
</style>
